// Types
import { SafePoktParams } from 'hooks/useSafePOKT'
import { poktToNodes, msToDays, msToDate, SharesUntilNewNode } from 'hooks/useSafePOKT/useSafePOKT.utils'
import { HomeCard } from './homePage.types'

export const getCards = (realPoktPrice: number, totalStake: number, poktPerShare: number, epochDuration: number, nextEpoch: number): HomeCard[] => [
  {
    key: SafePoktParams.GetNetAPR,
    label: 'Net APY',
    icon: 'savings',
    statConfig: { unit: '%', prefix: false },
    info: `Net Annual Percentage Yield (estimated).`,
    fractionDigits: 2
  },
  // {
  //   key: SafePoktParams.NodeCount,
  //   label: 'Owned Nodes',
  //   statConfig: {},
  //   subStatConfig: { unit: 'Staked POKT: ', prefix: true },
  //   subStat: SafePoktParams.TotalPOKTStake,
  //   icon: 'dns',
  // },
  {
    key: SafePoktParams.TotalPOKTStake,
    label: 'Staked POKT',
    statConfig: { token: { image: 'POKT' } },
    subStatConfig: { unit: 'Nodes', bold: true },
    subStat: (staked: number) => poktToNodes(staked),
    icon: 'trending_up',
    info: `Total POKT staked to nodes.`,
  },
//  {
//    key: SafePoktParams.TotalClaimableRewards,
//    label: 'Claimable Rewards',
//   statConfig: { unit: '$', prefix: true },
//    icon: 'paid',
//    info: `Total USDC earned and distributed by the protocol.`,
//  },
   {
    key: SafePoktParams.PoktPerShare,
    label: 'POKT x Share',
    statConfig: { token: { image: 'POKT' }, unit: 'PPS' },
    icon: 'currency_exchange',
    info: `POKT Per Share (PPS) refers to how many POKT tokens correspond to one Share.`,
  },
  {
    key: SafePoktParams.TotalRewardsPOKT,
    label: 'Total Rewards',
    statConfig: { unit: 'POKT' },
    //icon: 'paid',
    icon: 'emoji_events',
    info: `Total POKT earned from node servicing.`,
  },
  {
    key: SafePoktParams.CurrentEpoch,
    label: 'Current Epoch',
    statConfig: { unit: '#', prefix: true },
    subStat: () => msToDays(epochDuration),
    subStatConfig: { unit: 'Duration\n', prefix: true },
    icon: 'view_timeline',
  },
  {
    key: SafePoktParams.TotalShares,
    label: 'Total Shares',
    statConfig: { unit: 'Shares' },
    icon: 'account_balance',
    //info: `Number of POKT Shares.`,
  },
  /*{
    key: SafePoktParams.NewInvestments,
    label: 'Investments',
    statConfig: { unit: '$', prefix: true },
    icon: 'pending',
    info: `New share sale revenue that is still to be invested.`,
    subStatConfig: { unit: 'Nodes' },
    subStat: (newInvestments: number) => usdToNodes(newInvestments, poktPrice),
  },
  {
    key: SafePoktParams.TotalInvestmentsInUSDC,
    label: 'Total Investment',
    statConfig: { unit: '$', prefix: true },
    icon: 'savings',
  },*/
  {
    key: realPoktPrice,
    label: 'POKT Price',
    statConfig: { unit: '$', prefix: true },
    icon: 'price_change',
    //info: `New share sale revenue that is still to be invested.`,
    //subStatConfig: { unit: 'Nodes' },
    //subStat: (newInvestments: number) => usdToNodes(newInvestments, poktPrice),
    fractionDigits: 4,
  },
  {
    key: SharesUntilNewNode(totalStake, poktPerShare),
    label: 'Node Progress',
    statConfig: { unit: 'Shares' },
    icon: 'dns',
    info: `Needed Shares to stake a new node.`,
    fractionDigits: (SharesUntilNewNode(totalStake, poktPerShare) > 1000)?1:0,
  },
  {
    key: SafePoktParams.HolderCount,
    label: 'Holder Count',
    statConfig: { unit: 'Holders' },
    icon: 'groups',
  },
  {
    key: SafePoktParams.NextEpochTime,
    statConfig: { notANumber: true },
    label: 'Next Epoch',
    subStat: () => msToDate(nextEpoch),
    subStatConfig: { unit: 'Date\n', prefix: true },
    icon: 'hourglass_top',
    info: `Remaining days until next distribution of rewards (estimated).`,
  },
]
